<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Assign Parts to Skid</p>
          <button
            class="delete"
            aria-label="close"
            @click="close(true)">
          </button>
        </header>

        <v-form class="modal-card-body" :valid.sync="valid">
          <template v-if="!addingNew">
            <div class="field" >
              <label class="label">Skid*</label>
              <v-select 
                required
                :options="skids"
                item-text="skid_no"
                item-value="id"
                :value="skid.id"
                @input="setSkid($event)"
              />
            </div>
            <button 
              class="button is-primary"
              @click="addingNew = true">
              Assign Parts to a New Skid
            </button>
          </template>
          <template v-else>
            <div class="field">
              <label class="label">Skid Description</label>
              <v-text-field
                placeholder="Enter packing instructions"
                v-model="skid.desc">
              </v-text-field>
            </div>
          </template>
        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="assignPartsToSkid()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VSelect from '@/components/base/VSelect'
import VTextField from '@/components/base/VTextField'
import VForm from '@/components/base/VForm'

import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    skids: {
      type: Array
    },
    projectId: {
      type: [String, Number],
      required: true
    },
    parts: {
      type: Array,
      required: true
    }
  },
  components: { VTextField, VSelect, VForm },
  data() {
    return {
      skid: {
        desc: '',
        parts: []
      },
      valid: false,
      addingNew: false
    }
  },
  watch: {
    value(state) {
      if (state) {
        if (this.skids.length == 0) {
          this.addingNew = true;
        } else {
          this.addingNew = false;
        }
      }
    }
  },
  methods: {
    ...mapActions("skids", ["addSkid", "updateSkid", "getSkids"]),
    ...mapMutations("app", ["setNotification"]),
    assignPartsToSkid() {
      if (this.addingNew) {
        this.skid.parts = this.parts;
        this.addSkid(
          { data: this.skid, parameters: { project_id: this.projectId } }
        ).then(
          () => {
            this.notifySuccess('Parts successfully assigned to new skid');
            this.close(true);
          }
        )
      } else {
        this.skid.parts = [...this.skid.parts.map(d => d.id), ...this.parts];
        this.updateSkid(
          { skidId: this.skid.id, data: this.skid }
        ).then(
          () => {
            this.notifySuccess(`Parts successfully assigned to skid ${this.skid.skid_no}`);
            this.close(true);
          }
        )
      }
    },
    notifySuccess(msg) {
      this.getSkids();
      
      this.setNotification({
        status: true,
        type: 'success',
        message: msg
      });
    },
    setSkid(skidId) {
      this.skid = this.skids.filter(d => d.id == skidId)[0];
    },  
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>